import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/outline";
import { PlusIcon } from "@heroicons/react/solid";
import { useSession, signOut } from "next-auth/react";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";

import Logo from "../public/survyy-logo.png";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function MarketingNav() {
  const router = useRouter();
  const { team_id } = router.query;

  return (
    <Disclosure as="nav" className=" marketing-nav">
      <>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 justify-between">
            <div className="flex">
              <div className="-ml-2 mr-2 flex items-center md:hidden">
                {/* Mobile menu button */}
              </div>
              <div className="flex flex-shrink-0 items-center">
                <svg
                  className="mktg-logo"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3.286 15c-1.104 0-1.88-.65-2.629-1.416l.622-.78c.577.662 1.175 1.196 2.007 1.196 1.057 0 1.739-.789 1.739-2s-.683-2-1.739-2c-2.368 0-3.569 5-6.571 5-1.599 0-2.715-1.227-2.715-3s1.116-3 2.715-3c1.105 0 1.881.65 2.631 1.417l-.622.781c-.578-.663-1.176-1.198-2.009-1.198-1.057 0-1.74.789-1.74 2s.684 2 1.74 2c2.364 0 3.562-5 6.571-5 1.599 0 2.714 1.227 2.714 3s-1.115 3-2.714 3z" />
                </svg>
              </div>
            </div>
            <div className="hidden md:ml-6 md:flex md:space-x-8">
              <Link href="#features">
                <a className="inline-flex items-center hover:text-indigo-600  px-1 pt-1 text-sm font-medium text-white">
                  features
                </a>
              </Link>

              <Link href="#pricing">
                <a className="inline-flex items-center hover:text-indigo-600  px-1 pt-1 text-sm font-medium text-white">
                  pricing
                </a>
              </Link>

              <Link href="#early-access">
                <a className="inline-flex items-center hover:text-indigo-600 px-1 pt-1 text-sm font-medium text-gray-900">
                  <div className="rounded-3xl  py-2 px-4 text-white right-0 marketing-btn-gradient">
                    get early access
                  </div>
                </a>
              </Link>
            </div>
          </div>
        </div>
      </>
    </Disclosure>
  );
}
